import {
  AddMenuPlugin,
  AdvancedMenuPlugin,
  Audio,
  BlockDottedLine,
  BlockIdGenerator,
  BlockMenu,
  BlockMenuButton,
  Blockquote,
  Bold,
  BulletList,
  Callout,
  CheckList,
  CheckListItem,
  Code,
  CodeBlock,
  CodeFence,
  CodeInline,
  Color,
  ColorHighlighter,
  Doc,
  Embed,
  File,
  FlashCard,
  HandleBackSpace,
  HardBreak,
  Heading,
  HorizontalRule,
  Image,
  Italic,
  Link,
  LinkMenu,
  ListItem,
  MathDisplay,
  MathInline,
  NewLine,
  OrderedList,
  Paragraph,
  Placeholder,
  SpacerBlock,
  Strikethrough,
  Tab,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  TabPanel,
  TabView,
  Text,
  ToggleContent,
  ToggleHeading,
  ToggleList,
  ToggleListItem,
  TooltipToolbar,
  TransformPastedContent,
  TypographyInputRules,
  Underline,
  Video,
  WebBookmark,
} from '@lyearn/lygo-blocks';

import LyVideoRestrictedForwarding from '../nodes/LyVideoRestrictedForwarding';

const commonLyExtensions = [
  Code,
  CodeInline,
  CodeFence,
  Doc,
  Paragraph,
  Heading,
  HorizontalRule,
  Blockquote,
  ListItem,
  OrderedList,
  SpacerBlock,
  BulletList,
  Image,
  File,
  Text,
  MathInline,
  MathDisplay,
  HardBreak,
  Embed,
  Table,
  Tab,
  TabPanel,
  TabView,
  TableHeader,
  TableRow,
  TableCell,
  ToggleList,
  ToggleListItem,
  ToggleHeading,
  ToggleContent,
  CheckList,
  CheckListItem,
  WebBookmark,
  LinkMenu,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  CodeBlock,
  Link,
  Color,
  Callout,
  TooltipToolbar,
  BlockIdGenerator,
  BlockMenuButton,
  BlockMenu,
  ColorHighlighter,
  TypographyInputRules,
  Placeholder,
  AddMenuPlugin,
  AdvancedMenuPlugin,
  NewLine,
  HandleBackSpace,
  TransformPastedContent,
  Audio,
  FlashCard,
  BlockDottedLine,
];

const lyExtensions = [...commonLyExtensions, Video];

export const getLyExtensions = ({ isDefaultRestricted }: { isDefaultRestricted?: boolean }) =>
  isDefaultRestricted ? [...commonLyExtensions, LyVideoRestrictedForwarding] : lyExtensions;
